export const sortObjectsByNameWithoutAccents = (arrayObjects) => {
  if (!arrayObjects || !arrayObjects?.length) return
  const sortedObjects = arrayObjects?.slice()?.sort((obj1, obj2) => {
    return obj1?.name?.localeCompare(obj2?.name, 'en', { sensitivity: 'base' })
  })
  return sortedObjects
}
